// yololife-product-gallery.js — 缩略图/变体切换 product 详情页主图 (T55 2026-05-28).
// 渲染于 sections/product.liquid。
(function () {
  var mediaClasses = ['yl-media--standard', 'yl-media--wide', 'yl-media--tall'];
  var MIN_LOADING_MS = 160;
  var ZOOM_MAX_SCALE = 2.75;
  var SWIPE_MIN_DISTANCE = 48;
  var SWIPE_AXIS_RATIO = 1.25;
  var SWIPE_CLICK_SUPPRESS_MS = 600;
  var preloadedImages = {};

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function hideZoomPreview(media) {
    var preview = media && media.querySelector('[data-product-zoom-preview]');
    var focus = media && media.querySelector('[data-product-zoom-focus]');
    if (preview) preview.classList.remove('is-active');
    if (focus) focus.classList.remove('is-active');
  }

  function getContainedImageRect(frame, hero) {
    if (!frame || !hero || !hero.naturalWidth || !hero.naturalHeight) return null;

    var frameRect = frame.getBoundingClientRect();
    if (!frameRect.width || !frameRect.height) return null;

    var imageScale = Math.min(
      frameRect.width / hero.naturalWidth,
      frameRect.height / hero.naturalHeight
    );
    var width = hero.naturalWidth * imageScale;
    var height = hero.naturalHeight * imageScale;

    return {
      frameRect: frameRect,
      left: (frameRect.width - width) / 2,
      top: (frameRect.height - height) / 2,
      width: width,
      height: height
    };
  }

  // The hero loads at its displayed size (sizes 50vw), which blurs at 2.6x zoom. Ask the
  // Shopify CDN for a wide copy for the zoom pane only (its width param).
  function zoomSource(src) {
    if (!src || !/[?&]width=\d+/.test(src)) return src;
    return src.replace(/([?&]width=)\d+/, function (_, key) { return key + '2400'; });
  }

  function updateZoomPreview(media, event) {
    var frame = media && media.querySelector('.yl-product__media-main');
    var hero = media && media.querySelector('.yl-product__hero');
    var preview = media && media.querySelector('[data-product-zoom-preview]');
    var focus = media && media.querySelector('[data-product-zoom-focus]');
    var finePointer = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    if (!frame || !hero || !preview || !focus || !finePointer || event.pointerType === 'touch') {
      hideZoomPreview(media);
      return;
    }

    var imageRect = getContainedImageRect(frame, hero);
    if (!imageRect) {
      hideZoomPreview(media);
      return;
    }

    var localX = event.clientX - imageRect.frameRect.left;
    var localY = event.clientY - imageRect.frameRect.top;
    var imageRight = imageRect.left + imageRect.width;
    var imageBottom = imageRect.top + imageRect.height;
    if (
      localX < imageRect.left || localX > imageRight ||
      localY < imageRect.top || localY > imageBottom
    ) {
      hideZoomPreview(media);
      return;
    }

    var previewLeft = imageRect.frameRect.right + 12;
    var availablePreviewWidth = window.innerWidth - previewLeft - 18;
    if (availablePreviewWidth < 320) {
      hideZoomPreview(media);
      return;
    }

    var previewWidthTarget = Math.min(window.innerWidth * 0.58, 1184);
    var previewHeight = Math.max(
      imageRect.frameRect.height,
      Math.min(window.innerHeight * 0.82, 896)
    );
    preview.style.top = Math.max(0, imageRect.frameRect.top) + 'px';
    preview.style.left = previewLeft + 'px';
    preview.style.width = Math.min(previewWidthTarget, availablePreviewWidth) + 'px';
    preview.style.height = previewHeight + 'px';
    var previewWidth = preview.offsetWidth;
    var previewHeight = preview.offsetHeight;
    if (!previewWidth || !previewHeight) {
      hideZoomPreview(media);
      return;
    }

    var sourceScale = Math.min(
      hero.naturalWidth / imageRect.width,
      hero.naturalHeight / imageRect.height
    );
    var fillScale = Math.max(
      previewWidth / imageRect.width,
      previewHeight / imageRect.height
    );
    var zoomScale = Math.min(ZOOM_MAX_SCALE, Math.max(fillScale, sourceScale, 2.6));
    var focusWidth = Math.min(imageRect.width, previewWidth / zoomScale);
    var focusHeight = Math.min(imageRect.height, previewHeight / zoomScale);
    var focusLeft = clamp(
      localX - (focusWidth / 2),
      imageRect.left,
      imageRight - focusWidth
    );
    var focusTop = clamp(
      localY - (focusHeight / 2),
      imageRect.top,
      imageBottom - focusHeight
    );
    var backgroundX = -((focusLeft - imageRect.left) * zoomScale);
    var backgroundY = -((focusTop - imageRect.top) * zoomScale);
    var imageSrc = zoomSource(hero.currentSrc || hero.src);

    if (!imageSrc) {
      hideZoomPreview(media);
      return;
    }

    focus.style.left = focusLeft + 'px';
    focus.style.top = focusTop + 'px';
    focus.style.width = focusWidth + 'px';
    focus.style.height = focusHeight + 'px';
    preview.style.backgroundImage = 'url(' + JSON.stringify(imageSrc) + ')';
    preview.style.backgroundSize = (imageRect.width * zoomScale) + 'px ' + (imageRect.height * zoomScale) + 'px';
    preview.style.backgroundPosition = backgroundX + 'px ' + backgroundY + 'px';
    focus.classList.add('is-active');
    preview.classList.add('is-active');
  }

  function bindZoomPreview(media) {
    var trigger = media && media.querySelector('.yl-product__zoom-trigger');
    var hero = media && media.querySelector('.yl-product__hero');
    if (!trigger || !hero || media.dataset.galleryZoomBound === 'true') return;
    media.dataset.galleryZoomBound = 'true';

    trigger.addEventListener('pointermove', function (event) {
      updateZoomPreview(media, event);
    });
    trigger.addEventListener('pointerleave', function () {
      hideZoomPreview(media);
    });
    trigger.addEventListener('pointercancel', function () {
      hideZoomPreview(media);
    });
    document.addEventListener('pointermove', function (event) {
      if (!trigger.contains(event.target)) hideZoomPreview(media);
    }, { passive: true });
    hero.addEventListener('load', function () {
      hideZoomPreview(media);
    });
    window.addEventListener('resize', function () {
      hideZoomPreview(media);
    });
    window.addEventListener('scroll', function () {
      hideZoomPreview(media);
    }, { passive: true });
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function getImageFromButton(btn) {
    return {
      id: btn.dataset.imageId || '',
      src: btn.dataset.fullSrc || '',
      thumbSrc: btn.dataset.thumbSrc || btn.dataset.fullSrc || '',
      ratio: btn.dataset.imageRatio || '1.333',
      mediaClass: btn.dataset.mediaClass || 'yl-media--standard',
      alt: btn.dataset.alt || ''
    };
  }

  function preloadImage(image) {
    if (!image || !image.src || preloadedImages[image.src]) return;
    preloadedImages[image.src] = 'loading';

    var preload = new Image();
    preload.decoding = 'async';
    preload.onload = function () {
      markImageLoaded(image.src);
    };
    preload.onerror = function () {
      preloadedImages[image.src] = 'error';
    };
    preload.src = image.src;
    if (typeof preload.decode === 'function') {
      var decoded = preload.decode();
      if (decoded && typeof decoded.then === 'function') {
        decoded.then(function () {
          markImageLoaded(image.src);
        }).catch(function () {});
      }
    }
  }

  function markImageLoaded(src) {
    if (!src) return;
    preloadedImages[src] = 'loaded';
  }

  function isImageLoaded(src) {
    return Boolean(src && preloadedImages[src] === 'loaded');
  }

  function scrollThumb(btn) {
    if (!btn || typeof btn.scrollIntoView !== 'function') return;
    var raf = window.requestAnimationFrame || function (callback) {
      return window.setTimeout(callback, 0);
    };
    raf(function () {
      btn.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    });
  }

  function setGalleryLoading(media, loading) {
    var frame = media && media.querySelector('.yl-product__media-main');
    if (!frame) return;
    if (loading) media.dataset.galleryLoadingStartedAt = String(Date.now());
    else delete media.dataset.galleryLoadingStartedAt;
    frame.classList.toggle('is-loading', Boolean(loading));
    frame.setAttribute('aria-busy', loading ? 'true' : 'false');
  }

  function finishHeroLoad(media, expectedSrc) {
    if (!media || media.dataset.galleryPendingSrc !== expectedSrc) return;
    markImageLoaded(expectedSrc);
    var loadingStartedAt = Number(media.dataset.galleryLoadingStartedAt) || 0;
    var remainingMs = MIN_LOADING_MS - (Date.now() - loadingStartedAt);
    if (remainingMs > 0) {
      window.setTimeout(function () {
        finishHeroLoad(media, expectedSrc);
      }, remainingMs);
      return;
    }
    delete media.dataset.galleryPendingSrc;
    setGalleryLoading(media, false);
  }

  function scheduleGalleryLoading(media, hero, expectedSrc) {
    if (isImageLoaded(expectedSrc)) return;

    var raf = window.requestAnimationFrame || function (callback) {
      return window.setTimeout(callback, 0);
    };
    raf(function () {
      if (!media || media.dataset.galleryPendingSrc !== expectedSrc) return;
      if (hero.complete || isImageLoaded(expectedSrc)) {
        finishHeroLoad(media, expectedSrc);
        return;
      }
      setGalleryLoading(media, true);
    });
  }

  function setFrame(frame, image) {
    if (!frame || !image) return;
    if (image.ratio) frame.style.setProperty('--yl-image-ratio', image.ratio);
    mediaClasses.forEach(function (className) {
      frame.classList.remove(className);
    });
    frame.classList.add(image.mediaClass || 'yl-media--standard');
  }

  function setHero(media, image) {
    var hero = media.querySelector('.yl-product__hero');
    var frame = media.querySelector('.yl-product__media-main');
    if (!hero || !image || !image.src) return;

    hideZoomPreview(media);
    var nextSrc = image.src;
    media.dataset.galleryPendingSrc = nextSrc;
    media.dataset.galleryCurrentSrc = nextSrc;
    setGalleryLoading(media, false);
    hero.onload = function () {
      finishHeroLoad(media, nextSrc);
    };
    hero.onerror = function () {
      finishHeroLoad(media, nextSrc);
    };

    // hero 初始带 widths 生成的 srcset；清掉让单一 1600 大图 src 生效。
    hero.removeAttribute('srcset');
    hero.alt = image.alt || media.dataset.productTitle || '';
    setFrame(frame, image);
    hero.src = nextSrc;

    if (hero.complete) {
      finishHeroLoad(media, nextSrc);
    } else {
      scheduleGalleryLoading(media, hero, nextSrc);
    }
  }

  function markActiveThumb(media, activeBtn) {
    media.querySelectorAll('.yl-product__thumb').forEach(function (btn) {
      btn.classList.remove('is-active');
      btn.removeAttribute('aria-current');
    });
    if (!activeBtn) return;
    activeBtn.classList.add('is-active');
    activeBtn.setAttribute('aria-current', 'true');
  }

  function getThumbs(media) {
    return Array.prototype.slice.call(media.querySelectorAll('.yl-product__thumb'));
  }

  function updateNavState(media) {
    media.classList.toggle('yl-product__media--can-nav', getThumbs(media).length > 1);
  }

  function updateGalleryCount(media, activeBtn) {
    var count = media.querySelector('[data-gallery-count]');
    if (!count) return;

    var thumbs = getThumbs(media);
    if (thumbs.length <= 1) {
      count.hidden = true;
      return;
    }

    var active = activeBtn || thumbs.find(function (thumb) {
      return thumb.classList.contains('is-active');
    }) || thumbs[0];
    var activeIndex = thumbs.indexOf(active);
    if (activeIndex < 0) activeIndex = 0;

    count.hidden = false;
    count.textContent = (activeIndex + 1) + ' / ' + thumbs.length;
  }

  // imagesOnly skips the video tile (2026-11-02): the fullscreen image dialog has no video player.
  function getNextThumb(media, direction, imagesOnly) {
    var thumbs = getThumbs(media);
    if (thumbs.length <= 1) return null;

    var activeIndex = thumbs.findIndex(function (thumb) {
      return thumb.classList.contains('is-active');
    });
    var nextIndex = activeIndex < 0 ? 0 : (activeIndex + direction + thumbs.length) % thumbs.length;
    for (var step = 0; imagesOnly && step < thumbs.length && thumbs[nextIndex].hasAttribute('data-video-thumb'); step++) {
      nextIndex = (nextIndex + direction + thumbs.length) % thumbs.length;
    }
    return thumbs[nextIndex];
  }

  function preloadAdjacent(media) {
    var thumbs = getThumbs(media);
    if (thumbs.length <= 1) return;

    var activeIndex = thumbs.findIndex(function (thumb) {
      return thumb.classList.contains('is-active');
    });
    if (activeIndex < 0) activeIndex = 0;

    [activeIndex - 1, activeIndex + 1].forEach(function (index) {
      var thumb = thumbs[(index + thumbs.length) % thumbs.length];
      if (thumb) preloadImage(getImageFromButton(thumb));
    });
  }

  function activateThumb(media, btn, options) {
    if (!btn) return;
    var opts = options || {};
    var image = getImageFromButton(btn);
    preloadImage(image);
    markActiveThumb(media, btn);
    updateNavState(media);
    updateGalleryCount(media, btn);
    setHero(media, image);
    if (opts.scrollThumb !== false) scrollThumb(btn);
    preloadAdjacent(media);
    syncProductGalleryDialog(media);
  }

  function activateByDirection(media, direction, imagesOnly) {
    var nextThumb = getNextThumb(media, direction, imagesOnly);
    if (!nextThumb) return false;
    activateThumb(media, nextThumb);
    return true;
  }

  function isEditableTarget(target) {
    if (!target) return false;
    var tagName = (target.tagName || '').toLowerCase();
    return target.isContentEditable || tagName === 'input' || tagName === 'textarea' || tagName === 'select';
  }

  function bindThumbs(media) {
    var thumbs = getThumbs(media);
    thumbs.forEach(function (btn) {
      if (btn.dataset.galleryBound === 'true') return;
      btn.dataset.galleryBound = 'true';
      var primeImage = function () {
        preloadImage(getImageFromButton(btn));
      };
      btn.addEventListener('pointerenter', primeImage);
      btn.addEventListener('pointerdown', primeImage);
      btn.addEventListener('focus', primeImage);
      btn.addEventListener('click', function () {
        activateThumb(media, btn);
      });
    });
    updateNavState(media);
    updateGalleryCount(media);
    preloadAdjacent(media);
  }

  function bindNav(media) {
    media.querySelectorAll('[data-gallery-nav]').forEach(function (btn) {
      if (btn.dataset.galleryNavBound === 'true') return;
      btn.dataset.galleryNavBound = 'true';
      var direction = btn.dataset.galleryNav === 'prev' ? -1 : 1;
      btn.addEventListener('click', function () {
        activateByDirection(media, direction);
      });
    });
    updateNavState(media);
  }

  function bindKeyboardNav(media) {
    if (media.dataset.galleryKeyboardBound === 'true') return;
    media.dataset.galleryKeyboardBound = 'true';

    document.addEventListener('keydown', function (event) {
      if (!media.isConnected) return;
      if (event.defaultPrevented || event.metaKey || event.ctrlKey || event.altKey) return;
      if (isEditableTarget(event.target)) return;
      if (event.target.closest && event.target.closest('video')) return;

      if (event.key === 'ArrowLeft') {
        if (activateByDirection(media, -1)) event.preventDefault();
      } else if (event.key === 'ArrowRight') {
        if (activateByDirection(media, 1)) event.preventDefault();
      }
    });
  }

  function bindSwipeNav(media) {
    var trigger = media && media.querySelector('.yl-product__zoom-trigger');
    if (!trigger || media.dataset.gallerySwipeBound === 'true') return;
    media.dataset.gallerySwipeBound = 'true';

    var swipeStart = null;

    trigger.addEventListener('pointerdown', function (event) {
      var isTouchPointer = event.pointerType === 'touch' || event.pointerType === 'pen';
      if (!event.isPrimary || !isTouchPointer) return;

      swipeStart = {
        pointerId: event.pointerId,
        x: event.clientX,
        y: event.clientY
      };

      if (typeof trigger.setPointerCapture === 'function') {
        try {
          trigger.setPointerCapture(event.pointerId);
        } catch (error) {}
      }
    });

    trigger.addEventListener('pointerup', function (event) {
      if (!swipeStart || event.pointerId !== swipeStart.pointerId) return;

      var deltaX = event.clientX - swipeStart.x;
      var deltaY = event.clientY - swipeStart.y;
      swipeStart = null;

      if (
        typeof trigger.releasePointerCapture === 'function' &&
        typeof trigger.hasPointerCapture === 'function' &&
        trigger.hasPointerCapture(event.pointerId)
      ) {
        try {
          trigger.releasePointerCapture(event.pointerId);
        } catch (error) {}
      }

      if (
        Math.abs(deltaX) < SWIPE_MIN_DISTANCE ||
        Math.abs(deltaX) <= Math.abs(deltaY) * SWIPE_AXIS_RATIO
      ) return;

      var direction = deltaX < 0 ? 1 : -1;
      if (!activateByDirection(media, direction)) return;

      media.dataset.gallerySuppressClickUntil = String(Date.now() + SWIPE_CLICK_SUPPRESS_MS);
      event.preventDefault();
    });

    trigger.addEventListener('pointercancel', function () {
      swipeStart = null;
    });

    trigger.addEventListener('click', function (event) {
      var suppressUntil = Number(media.dataset.gallerySuppressClickUntil) || 0;
      if (!suppressUntil || Date.now() > suppressUntil) {
        delete media.dataset.gallerySuppressClickUntil;
        return;
      }

      delete media.dataset.gallerySuppressClickUntil;
      event.preventDefault();
      event.stopPropagation();
    });
  }

  function getProductGalleryEntries(media) {
    // The image dialog lists images only; the video tile plays in the main viewer.
    var thumbs = getThumbs(media).filter(function (thumb) {
      return !thumb.hasAttribute('data-video-thumb');
    });
    if (thumbs.length) {
      return thumbs.map(function (thumb) {
        return {
          mainThumb: thumb,
          image: getImageFromButton(thumb)
        };
      });
    }

    var hero = media && media.querySelector('.yl-product__hero');
    if (!hero) return [];
    var src = hero.currentSrc || hero.src || '';
    if (!src) return [];

    return [{
      mainThumb: null,
      image: {
        id: src,
        src: src,
        thumbSrc: src,
        ratio: '1.333',
        mediaClass: 'yl-media--standard',
        alt: hero.alt || media.dataset.productTitle || ''
      }
    }];
  }

  function getProductGalleryActiveIndex(entries) {
    var activeIndex = entries.findIndex(function (entry) {
      return entry.mainThumb && entry.mainThumb.classList.contains('is-active');
    });
    return activeIndex < 0 ? 0 : activeIndex;
  }

  function renderProductGalleryThumbs(media, dialog, entries, activeIndex) {
    var list = dialog.querySelector('[data-product-gallery-thumbs]');
    if (!list) return;

    var signature = entries.map(function (entry) {
      return String(entry.image.id || entry.image.src || '');
    }).join('|');

    if (list.dataset.gallerySignature !== signature) {
      list.dataset.gallerySignature = signature;
      list.innerHTML = '';

      entries.forEach(function (entry, index) {
        var item = document.createElement('li');
        var button = document.createElement('button');
        var image = document.createElement('img');

        button.type = 'button';
        button.className = 'yl-product-gallery__thumb';
        button.dataset.productGalleryThumb = String(index);
        button.setAttribute('aria-label', media.dataset.viewImageLabel || media.dataset.productTitle || 'View image');
        image.src = entry.image.thumbSrc || entry.image.src;
        image.alt = entry.image.alt || '';
        image.loading = 'lazy';
        image.decoding = 'async';
        button.appendChild(image);
        item.appendChild(button);
        list.appendChild(item);

        button.addEventListener('click', function () {
          if (entry.mainThumb) activateThumb(media, entry.mainThumb);
          else syncProductGalleryDialog(media);
        });
      });
    }

    list.hidden = entries.length <= 1;
    list.querySelectorAll('[data-product-gallery-thumb]').forEach(function (button, index) {
      var isActive = index === activeIndex;
      button.classList.toggle('is-active', isActive);
      if (isActive) button.setAttribute('aria-current', 'true');
      else button.removeAttribute('aria-current');
    });
  }

  function syncProductGalleryDialog(media) {
    var dialog = media && media.querySelector('[data-product-gallery-dialog]');
    if (!dialog) return;

    var entries = getProductGalleryEntries(media);
    var image = dialog.querySelector('[data-product-gallery-image]');
    var count = dialog.querySelector('[data-product-gallery-count]');
    if (!entries.length || !image) return;

    var activeIndex = getProductGalleryActiveIndex(entries);
    var activeEntry = entries[activeIndex] || entries[0];
    var activeImage = activeEntry.image;
    if (image.src !== activeImage.src) image.src = activeImage.src;
    image.alt = activeImage.alt || '';
    image.dataset.imageId = String(activeImage.id || activeImage.src || '');
    if (count) count.textContent = (activeIndex + 1) + ' / ' + entries.length;

    dialog.querySelectorAll('[data-product-gallery-nav]').forEach(function (button) {
      button.hidden = entries.length <= 1;
    });
    renderProductGalleryThumbs(media, dialog, entries, activeIndex);

    if (entries.length > 1) {
      preloadImage(entries[(activeIndex - 1 + entries.length) % entries.length].image);
      preloadImage(entries[(activeIndex + 1) % entries.length].image);
    }
  }

  function openProductGalleryDialog(media) {
    var dialog = media && media.querySelector('[data-product-gallery-dialog]');
    if (!dialog || dialog.open || typeof dialog.showModal !== 'function') return;
    hideZoomPreview(media);
    syncProductGalleryDialog(media);
    dialog.showModal();
    document.body.classList.add('yl-product-gallery-open');
  }

  function closeProductGalleryDialog(media) {
    var dialog = media && media.querySelector('[data-product-gallery-dialog]');
    if (dialog && dialog.open) dialog.close();
    document.body.classList.remove('yl-product-gallery-open');
  }

  function bindDialogSwipe(media, dialog) {
    var stage = dialog && dialog.querySelector('[data-product-gallery-stage]');
    if (!stage || stage.dataset.gallerySwipeBound === 'true') return;
    stage.dataset.gallerySwipeBound = 'true';
    var swipeStart = null;

    stage.addEventListener('pointerdown', function (event) {
      var isTouchPointer = event.pointerType === 'touch' || event.pointerType === 'pen';
      if (event.isPrimary === false || !isTouchPointer) return;
      swipeStart = {
        pointerId: event.pointerId,
        x: event.clientX,
        y: event.clientY
      };
      if (typeof stage.setPointerCapture === 'function') {
        try {
          stage.setPointerCapture(event.pointerId);
        } catch (error) {}
      }
    });

    stage.addEventListener('pointerup', function (event) {
      if (!swipeStart || event.pointerId !== swipeStart.pointerId) return;
      var deltaX = event.clientX - swipeStart.x;
      var deltaY = event.clientY - swipeStart.y;
      swipeStart = null;

      if (
        Math.abs(deltaX) < SWIPE_MIN_DISTANCE ||
        Math.abs(deltaX) <= Math.abs(deltaY) * SWIPE_AXIS_RATIO
      ) return;

      if (activateByDirection(media, deltaX < 0 ? 1 : -1, true)) {
        event.preventDefault();
      }
    });

    stage.addEventListener('pointercancel', function () {
      swipeStart = null;
    });
  }

  function bindProductGalleryDialog(media) {
    var trigger = media && media.querySelector('[data-product-gallery-open]');
    var dialog = media && media.querySelector('[data-product-gallery-dialog]');
    if (!trigger || !dialog || media.dataset.productGalleryDialogBound === 'true') return;
    media.dataset.productGalleryDialogBound = 'true';

    trigger.addEventListener('click', function (event) {
      if (event.defaultPrevented) return;
      openProductGalleryDialog(media);
    });

    var closeButton = dialog.querySelector('[data-product-gallery-close]');
    if (closeButton) {
      closeButton.addEventListener('click', function () {
        closeProductGalleryDialog(media);
      });
    }

    dialog.querySelectorAll('[data-product-gallery-nav]').forEach(function (button) {
      button.addEventListener('click', function () {
        activateByDirection(media, button.dataset.productGalleryNav === 'prev' ? -1 : 1, true);
      });
    });

    dialog.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        event.stopPropagation();
        closeProductGalleryDialog(media);
        return;
      }
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      event.stopPropagation();
      activateByDirection(media, event.key === 'ArrowLeft' ? -1 : 1, true);
    });

    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) closeProductGalleryDialog(media);
    });

    dialog.addEventListener('close', function () {
      document.body.classList.remove('yl-product-gallery-open');
    });

    bindDialogSwipe(media, dialog);
    syncProductGalleryDialog(media);
  }

  function bindInitialHeroLoad(media) {
    var hero = media && media.querySelector('.yl-product__hero');
    if (!hero || media.dataset.galleryInitialLoadBound === 'true') return;
    media.dataset.galleryInitialLoadBound = 'true';

    var initialSrc = hero.currentSrc || hero.src || '';
    if (!initialSrc) return;

    media.dataset.galleryCurrentSrc = initialSrc;
    if (hero.complete && hero.naturalWidth > 0) {
      markImageLoaded(initialSrc);
      return;
    }

    media.dataset.galleryPendingSrc = initialSrc;
    setGalleryLoading(media, true);

    var finishInitial = function () {
      finishHeroLoad(media, initialSrc);
    };
    hero.addEventListener('load', finishInitial, { once: true });
    hero.addEventListener('error', finishInitial, { once: true });
  }

  function thumbMarkup(media, image, isActive) {
    var label = media.dataset.viewImageLabel || media.dataset.productTitle || 'View image';
    var alt = image.alt || media.dataset.productTitle || '';
    var ratio = image.ratio || '1.333';
    var mediaClass = image.mediaClass || 'yl-media--standard';

    return [
      '<li>',
      '<button type="button" class="yl-product__thumb' + (isActive ? ' is-active' : '') + '"',
      ' data-image-id="' + escapeHtml(image.id) + '"',
      ' data-full-src="' + escapeHtml(image.src) + '"',
      ' data-thumb-src="' + escapeHtml(image.thumbSrc || image.src) + '"',
      ' data-image-ratio="' + escapeHtml(ratio) + '"',
      ' data-media-class="' + escapeHtml(mediaClass) + '"',
      ' data-alt="' + escapeHtml(alt) + '"',
      isActive ? ' aria-current="true"' : '',
      ' aria-label="' + escapeHtml(label) + '">',
      '<img src="' + escapeHtml(image.thumbSrc || image.src) + '" alt="' + escapeHtml(alt) + '" loading="lazy" decoding="async">',
      '</button>',
      '</li>'
    ].join('');
  }

  function renderThumbs(media, images, activeImageId) {
    var thumbs = media.querySelector('.yl-product__thumbs');
    if (!thumbs) return;

    if (!images || images.length <= 1) {
      media.classList.remove('yl-product__media--with-thumbs');
      thumbs.hidden = true;
      thumbs.innerHTML = '';
      updateNavState(media);
      updateGalleryCount(media);
      syncProductGalleryDialog(media);
      return;
    }

    media.classList.add('yl-product__media--with-thumbs');
    thumbs.hidden = false;
    thumbs.innerHTML = images.map(function (image, index) {
      var isActive = activeImageId ? String(image.id) === String(activeImageId) : index === 0;
      return thumbMarkup(media, image, isActive);
    }).join('');
    bindThumbs(media);
    updateNavState(media);
    updateGalleryCount(media);
    syncProductGalleryDialog(media);
  }

  function findImageById(images, imageId) {
    if (!images || !imageId) return null;
    for (var i = 0; i < images.length; i += 1) {
      if (String(images[i].id) === String(imageId)) return images[i];
    }
    return null;
  }

  function resolveGalleryImages(variantGallery, variant) {
    var images = variantGallery.allImages || [];

    var activeImage = findImageById(images, variant.featuredImageId) ||
      images[0];

    return {
      images: images,
      activeImage: activeImage,
      activeImageId: activeImage && activeImage.id
    };
  }

  function updateVariantUrl(variantId) {
    if (!variantId || !window.history || !window.URLSearchParams) return;

    var params = new URLSearchParams(window.location.search);
    params.set('variant', variantId);

    var nextUrl = window.location.pathname + '?' + params.toString() + window.location.hash;
    window.history.replaceState({ path: nextUrl }, '', nextUrl);
  }

  function updateVariantPrice(product, input) {
    var price = product.querySelector('.yl-product__price');
    if (!price || !input || !input.dataset.priceHtml) return;
    price.innerHTML = input.dataset.priceHtml;
  }

  function initVariantGallery(media) {
    var product = media.closest('.yl-product');
    var dataNode = product && product.querySelector('[data-variant-gallery]');
    if (!dataNode) return;

    var variantGallery;
    try {
      variantGallery = JSON.parse(dataNode.textContent);
    } catch (error) {
      return;
    }
    if (!variantGallery || !variantGallery.variants) return;

    product.querySelectorAll('input[name="id"]').forEach(function (input) {
      input.addEventListener('change', function () {
        if (!input.checked) return;

        var variant = variantGallery.variants[input.value];
        if (!variant) return;

        var resolvedGallery = resolveGalleryImages(variantGallery, variant);
        setHero(media, resolvedGallery.activeImage);
        renderThumbs(media, resolvedGallery.images, resolvedGallery.activeImageId);
        updateVariantPrice(product, input);
        updateVariantUrl(input.value);
      });
    });
  }

  function initGallery(media) {
    if (!media.querySelector('.yl-product__hero')) return;
    bindInitialHeroLoad(media);
    bindThumbs(media);
    bindNav(media);
    bindKeyboardNav(media);
    bindZoomPreview(media);
    bindSwipeNav(media);
    bindProductGalleryDialog(media);
    initVariantGallery(media);
  }

  document.querySelectorAll('.yl-product__media').forEach(initGallery);
})();
